import { useMantineTheme } from '@mantine/core';
import dayjs from 'dayjs';
import React from 'react';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip as RechartsTooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { abbreviateNumber, formatDateTime } from '@portals/utils';

export interface UsageBasedLineChartProps {
  chartData: Array<{ timestamp: string; value: unknown }>;
  usageBasedUnitName: string | null;
  usageBasedDisplayName: string | null;
}

export function UsageBasedLineChart({
  chartData,
  usageBasedUnitName,
  usageBasedDisplayName,
}: UsageBasedLineChartProps) {
  console.log(chartData);
  const theme = useMantineTheme();

  return (
    <ResponsiveContainer width="100%" height={200}>
      <LineChart data={chartData}>
        <RechartsTooltip
          labelFormatter={(label) => formatDateTime(label)}
          formatter={(value) => [
            `${value}${usageBasedUnitName}`,
            usageBasedDisplayName,
          ]}
        />

        <CartesianGrid vertical={false} stroke={theme.colors.gray[2]} />

        <XAxis
          interval="preserveStartEnd"
          dataKey="timestamp"
          tickFormatter={(value) => dayjs(value).format('MMM DD')}
          color={theme.colors.gray[5]}
          tick={{ fill: theme.colors.gray[5] }}
          axisLine={{ stroke: theme.colors.gray[2] }}
        />

        <YAxis
          width={40}
          tickFormatter={(value) => abbreviateNumber(value)}
          tick={{ fill: theme.colors.gray[5] }}
          axisLine={{ stroke: theme.colors.gray[2] }}
        />

        <Line type="monotone" dataKey="value" stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  );
}
